import { render, staticRenderFns } from "./DeviceSelector.vue?vue&type=template&id=0f808042&scoped=true&"
import script from "./DeviceSelector.vue?vue&type=script&lang=js&"
export * from "./DeviceSelector.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSelector.vue?vue&type=style&index=0&id=0f808042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f808042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f808042')) {
      api.createRecord('0f808042', component.options)
    } else {
      api.reload('0f808042', component.options)
    }
    module.hot.accept("./DeviceSelector.vue?vue&type=template&id=0f808042&scoped=true&", function () {
      api.rerender('0f808042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/DeviceSelector.vue"
export default component.exports